// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 60rem;
  background: var(--white);
  border-radius: 1.2rem;
  display: flex;
  flex-direction: column;
}

.header {
  height: 5.6rem;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px -1px 0px 0px rgba(225, 227, 235, 0.7) inset;
}
.header .text {
  font-size: 2rem;
  line-height: 120%;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1d2533;
}
.header .icon-cancel {
  font-size: 1.8rem;
  cursor: pointer;
}

.content {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.content .intro {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: var(--black);
}
.content .list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-height: 34rem;
  overflow-y: auto;
}
.content .list-item {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.content .variant-name {
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 500;
  color: var(--black);
}
.content .change {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  font-size: 1.4rem;
  line-height: 1.8rem;
}
.content .change .label {
  color: var(--grey);
}
.content .change .value {
  color: var(--black);
  white-space: nowrap;
}
.content .regime {
  color: var(--red);
}

.actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  padding: 16px 24px 22px;
  border-top: 1px solid #eef0f4;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/shared/popups/jurisdiction-diff-popup/jurisdiction-diff-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2DAAA;AACF;AACE;EACE,eAAA;EACA,iBAAA;EAEA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGE;EACE,iBAAA;EACA,eAAA;AADJ;;AAKA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;AAIE;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJJ;AAOE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AALJ;AAQE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;AANJ;AAQI;EACE,kBAAA;AANN;AASI;EACE,mBAAA;EACA,mBAAA;AAPN;AAWE;EACE,iBAAA;AATJ;;AAaA;EAEE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,aAAA;AAXF","sourcesContent":[":host {\n  width: 60rem;\n  background: var(--white);\n  border-radius: 1.2rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  height: 5.6rem;\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0px -1px 0px 0px rgba(225, 227, 235, 0.7) inset;\n\n  & .text {\n    font-size: 2rem;\n    line-height: 120%;\n    // color: var(--black);\n    margin: 0;\n    font-size: 18px;\n    font-weight: 700;\n    color: #1d2533;\n  }\n\n  & .icon-cancel {\n    font-size: 1.8rem;\n    cursor: pointer;\n  }\n}\n\n.content {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n\n  & .intro {\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n    color: var(--black);\n  }\n\n  & .list {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    max-height: 34rem;\n    overflow-y: auto;\n  }\n\n  & .list-item {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  & .variant-name {\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n    font-weight: 500;\n    color: var(--black);\n  }\n\n  & .change {\n    display: flex;\n    justify-content: space-between;\n    gap: 2rem;\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n\n    & .label {\n      color: var(--grey);\n    }\n\n    & .value {\n      color: var(--black);\n      white-space: nowrap;\n    }\n  }\n\n  & .regime {\n    color: var(--red);\n  }\n}\n\n.actions {\n  // padding: 0 2rem 2rem;\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  padding: 16px 24px 22px;\n  border-top: 1px solid #eef0f4;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
